import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_DOMAIN = 'https://growandstayrich.com';
const DEFAULT_TITLE = 'Grow & Stay Rich | Generational Wealth & Tax-Free Retirement Strategies';
const DEFAULT_DESC = 'Licensed Financial Advisory Network helping families build lasting wealth through IRC Sec. 7702 tax-free growth, zero market downside protection, and Living Benefits.';
const DEFAULT_IMAGE = `${DEFAULT_DOMAIN}/images/og-priyanka-office.jpg`;

export default function SEOHead({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  keywords = 'financial planning, wealth building, retirement planning, tax-free strategies, living benefits, insurance advisory, IUL, annuities, NPN 21450620',
  canonicalUrl = '',
  ogImage = DEFAULT_IMAGE,
  ogType = 'website',
  path = ''
}) {
  const currentUrl = canonicalUrl || `${DEFAULT_DOMAIN}${path}`;

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'FinancialService',
    'name': 'Grow & Stay Rich',
    'legalName': 'HGI / Integrity Marketing Group Member Agency',
    'url': DEFAULT_DOMAIN,
    'logo': `${DEFAULT_DOMAIN}/images/logo/logo-512.png`,
    'image': DEFAULT_IMAGE,
    'telephone': '+1-903-231-3051',
    'email': 'info@growandstayrich.com',
    'identifier': 'NPN: 21450620',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': '2019 Holy Unity Ln',
      'addressLocality': 'St Paul',
      'addressRegion': 'TX',
      'postalCode': '75098',
      'addressCountry': 'US'
    },
    'areaServed': [
      { '@type': 'State', 'name': 'Texas' },
      { '@type': 'State', 'name': 'California' },
      { '@type': 'State', 'name': 'Colorado' },
      { '@type': 'State', 'name': 'Florida' },
      { '@type': 'State', 'name': 'Idaho' },
      { '@type': 'State', 'name': 'Illinois' },
      { '@type': 'State', 'name': 'Kansas' },
      { '@type': 'State', 'name': 'Ohio' },
      { '@type': 'State', 'name': 'South Carolina' }
    ],
    'knowsAbout': [
      'IRC Sec. 7702 Tax-Free Retirement',
      'Index Universal Life (IUL)',
      'Fixed Index Annuities (FIA)',
      'Living Benefits Protection',
      'Financial Needs Analysis (FNA)',
      'Estate & Legacy Preservation'
    ],
    'sameAs': [
      'https://www.facebook.com/people/Grow-And-Stay-Rich/61572905996150/',
      'https://www.linkedin.com/in/meet-priyanka-karn/',
      'https://x.com/GrowAndStayRich',
      'https://www.instagram.com/growandstayrich/'
    ]
  };

  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook / LinkedIn */}
      <meta property="og:site_name" content="Grow & Stay Rich" />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={currentUrl} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Google Search FinancialService / Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
}
